export default __webpack_public_path__ + "static/media/sudheerSingh1.5e4cab6c.jpg";